'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useAuthStore } from '../store/auth-store';
import { useRouter, usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { Toaster } from 'sonner';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: false,
            refetchOnWindowFocus: false,
        },
    },
});

interface ProvidersProps {
    children: React.ReactNode;
}

export function Providers({ children }: ProvidersProps) {
    const [mounted, setMounted] = useState(false);
    const { isAuthenticated, user } = useAuthStore();
    const router = useRouter();
    const pathname = usePathname();

    useEffect(() => {
        setMounted(true);
    }, []);

    useEffect(() => {
        if (!mounted) return;

        // Public routes that don't require authentication
        // /set-password: munkatárs-meghívó jelszó-beállító (WP-0.1) – token a linkben, nincs bejelentkezés
        const publicRoutes = ['/login', '/register', '/set-password'];

        if (!isAuthenticated && !publicRoutes.includes(pathname)) {
            router.push('/login');
        } else if (isAuthenticated && publicRoutes.includes(pathname)) {
            router.push('/');
        }
    }, [isAuthenticated, pathname, router, mounted]);

    // Avoid hydration mismatch
    if (!mounted) return null;

    return (
        <QueryClientProvider client={queryClient}>
            <Toaster position="top-right" richColors />
            {children}
        </QueryClientProvider>
    );
}
